import { IconType, defaultProps } from './types';

/**
 * Icono Tick
 */
export const Tick = ({
  className,
  width,
  height,
  color = defaultProps.color,
}: IconType): JSX.Element => (
  <svg
    {...(className ? { className: className } : {})}
    {...(width ? { width: width } : {})}
    {...(height ? { height: height } : {})}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 11"
  >
    <path d="M1 5.5 4.333 9 11 1" stroke={color} />
  </svg>
);
